import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-editcontrolledareabarrier',
    templateUrl: './editcontrolledareabarrier.component.html',
    styleUrls: ['./editcontrolledareabarrier.component.scss'],
    standalone: false
})
export class EditcontrolledareabarrierComponent extends SimpleModalComponent<any, null> {
  Form !: UntypedFormGroup;
  constructor() {
    super();
  }

  confirm() {
    this.close();
  }
}
